import { defineMessages } from 'react-intl';

export default defineMessages({
    docFailed: {
        id: 'gateway.directives.printdocuments.Document Failed',
        defaultMessage: 'Document Failed'
    },
    printQuoteFailureMsg: {
        id: 'gateway.directives.printdocuments.Unable to generate and save the print quote document.',
        defaultMessage: 'Unable to generate and save the print quote document.'
    },
    printAppQuoteFailureMsg: {
        id: 'gateway.directives.printdocuments.Unable to generate and save the print application document.',
        defaultMessage: 'Unable to generate and save the print application document.'
    },
    docSuccessed: {
        id: 'gateway.directives.printdocuments.Document Saved',
        defaultMessage: 'Document Saved'
    },
    printQuoteSuccessMsg: {
        id: 'gateway.directives.printdocuments.The print quote document saved successfully.',
        defaultMessage: 'The print quote document saved successfully.'
    },
    printAppQuoteSuccessMsg: {
        id: 'gateway.directives.printdocuments.The print application document saved successfully.',
        defaultMessage: 'The print application document saved successfully.'
    },
});
